export default "__VITE_ASSET__BHw30Llm__"